function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrecedent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m50.667 8h-17.408a2.7173 2.7173 0 0 1-1.192-0.26667l-8.416-4.224a8.0373 8.0373 0 0 0-3.576-0.84267h-6.7413a13.349 13.349 0 0 0-13.333 13.333v32a13.349 13.349 0 0 0 13.333 13.333h37.333a13.349 13.349 0 0 0 13.333-13.333v-26.667a13.349 13.349 0 0 0-13.333-13.333zm-37.333 0h6.7413a2.7173 2.7173 0 0 1 1.192 0.26667l8.416 4.2107a8.0373 8.0373 0 0 0 3.576 0.856h17.408a8 8 0 0 1 7.4107 5.0187l-52.744 0.29867v-2.6507a8 8 0 0 1 8-8zm37.333 48h-37.333a8 8 0 0 1-8-8v-24.016l53.333-0.30133v24.317a8 8 0 0 1-8 8z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecedent);
export default __webpack_public_path__ + "static/media/precedent.9ad886d9.svg";
export { ForwardRef as ReactComponent };